'use client'
import { FadeIn, FadeInStagger } from '@/components/ui/animation/faideIn'
import { buttonVariants } from '@/components/ui/button'
import { SvgArrowUpRight } from '@/components/ui/icons'
import { useActiveCohort } from '@/hooks/activeCohort'
import { getApplyRedirectUrl } from '@/lib/utils/functions'
import { cn } from '@/lib/utils/helpers'
import { useAuth } from '@/lib/utils/providers/supabase/supabase-auth-provider'
import Link from 'next/link'

const CTA = (props) => {
  const { session } = useAuth()
  const { cohort, isLoading } = useActiveCohort()

  return (
    <div className="max-w-7xl w-full px-6 lg:px-8 mx-auto mt-16 mb-24 font-sans">
      <div
        style={{
          background: '#0A0A0A',
          backgroundBlendMode: 'normal, overlay',
        }}
        className="relative p-[64px] rounded-2xl border border-[#424242] flex-col justify-start items-center gap-8 flex overflow-hidden"
      >
        <img
          // src="https://s3-alpha-sig.figma.com/img/61a0/5ae1/769972fdcaacdd8b89c5bb65030fcd54?Expires=1733097600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=al2htIgRP4DmBrJehYBaRKlg5L4jFRXbdmCoCTw4WZamhJ5OAvNuvqf9cd2I5Nbm21Ovxm43Fyl30PjWfsqAjgpYSKCtui2HEf2JZjdyH1-eD5NgIec-qmLCH8K2LoiRNKAHLInY8uTnacDj84PnEFst~sdlxskl02uooMmbk5PnYNVqePdsqWL6niVInv9ERf12qjqUeDXdD3~eiElBoLv-RTNDYJLc6~r5r3r4aBEoaZ1xfocqOa~91YeVwzYcddEhn5AbN5hgMBaBJrLF~vJr9-uiggmjYee6sVLuwLD9~XQ9C5hfWl~GDfoDK6W1pgknUfovioi5JSTyaan83A__"
          src="/images/home/cta.png"
          alt="cta_bg"
          loading="lazy"
          className=" absolute inset-0 h-full w-full object-cover"
        />
        <FadeInStagger
          faster
          className="relative max-w-3xl flex-col justify-start items-center gap-5 flex"
        >
          <FadeIn className="self-stretch text-center text-white text-4xl font-semibold leading-[44px]">
            Apply Today
          </FadeIn>
          <FadeIn className="self-stretch text-center text-white text-xl font-normal leading-[30px]">
            Put your project to the test and earn your spot in the next cohort
            by challenging our gatekeeper AI Annalese.
          </FadeIn>
          <FadeIn className="self-stretch text-center text-white text-xl font-normal leading-[30px]">
            <p className="text-white opacity-[.80] text-[16px] font-normal leading-[24px]">
              Application Deadline: {cohort?.deadline || ''}
            </p>
          </FadeIn>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            {props.program && (
              <FadeIn>
                <Link
                  href={'/about'}
                  className={cn(
                    buttonVariants({ variant: 'secondary', size: '2xl' }),
                    'max-sm:mx-auto leading-7 text-sm sm:text-lg  border border-[#98A2B3] bg-white/10 backdrop-blur-[20px] hover:shadow-none hover:border-[#98A2B3] ',
                  )}
                >
                  The Program <SvgArrowUpRight className="sm:ml-3" />
                </Link>
              </FadeIn>
            )}
            <FadeIn>
              <Link
                href={`${getApplyRedirectUrl(session)}`}
                className={cn(
                  buttonVariants({ size: '2xl' }),
                  'max-sm:mx-auto leading-7 w-full text-sm sm:text-lg mt-3 sm:mt-0',
                )}
              >
                Apply Now <SvgArrowUpRight className="sm:ml-3" />
              </Link>
            </FadeIn>
          </div>
        </FadeInStagger>
      </div>
    </div>
  )
}
export default CTA
